export default {
  'Operation administrator': '操作管理员',
  'Rule name': '规则名称',
  controller: '控制器',
  'data sheet': '数据表',
  'Modify line': '修改行',
  Modification: '修改项',
  'Before modification': '修改前',
  'After modification': '修改后',
  'Modification time': '修改时间',
  'Are you sure you want to rollback the record?': '确认要回滚记录吗？',
  'Rollback the selected record to the original data table':
    '回滚选中记录到原数据表',
  'Operator IP': '操作者IP',
  'Data table primary key': '数据表主键',
  'Modified item': '被修改项',
  'Modification comparison': '修改对比',
  RollBACK: '回滚'
}
